import { render, staticRenderFns } from "./edit-white.vue?vue&type=template&id=51fff8f7&"
import script from "./edit-white.vue?vue&type=script&lang=ts&"
export * from "./edit-white.vue?vue&type=script&lang=ts&"
import style0 from "./edit-white.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports